import React from "react";
import { Box, Skeleton, Stack, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";

/**
 * Skeleton loader for the Asset Management table. Mirrors the loaded
 * table layout (serial, owner, asset name + location, category chip,
 * value, investors avatar group, status chip, created date, action menu)
 * so the loading state has the same shape as the loaded page.
 */
export default function AdminAssetManagementSkeleton() {
  return (
    <Table sx={{ minWidth: 900 }}>
      <TableHead sx={{ bgcolor: (theme) => theme.palette.table.headBg }}>
        <TableRow>
          {[
            "Serial No.",
            "Owner",
            "Asset",
            "Category",
            "Value",
            "Investors",
            "Status",
            "Created At",
            "Actions",
          ].map((h) => (
            <TableCell key={h} sx={{ py: 2 }}>
              <Skeleton variant="text" width={70} height={16} />
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {[0, 1, 2, 3, 4].map((i) => (
          <TableRow key={i}>
            <TableCell sx={{ py: 2 }}>
              <Skeleton variant="text" width={36} height={18} />
            </TableCell>
            <TableCell>
              <Stack direction="row" alignItems="center" spacing={1}>
                <Skeleton variant="circular" width={36} height={36} />
                <Box>
                  <Skeleton variant="text" width={100} height={18} />
                  <Skeleton variant="text" width={70} height={14} />
                </Box>
              </Stack>
            </TableCell>
            <TableCell sx={{ py: 2 }}>
              <Box>
                <Skeleton variant="text" width={160} height={20} />
                <Skeleton variant="text" width={120} height={16} />
              </Box>
            </TableCell>
            <TableCell>
              <Skeleton variant="rounded" width={90} height={24} sx={{ borderRadius: 999 }} />
            </TableCell>
            <TableCell>
              <Skeleton variant="text" width={90} height={20} />
            </TableCell>
            <TableCell>
              <Skeleton variant="circular" width={28} height={28} />
            </TableCell>
            <TableCell>
              <Skeleton variant="rounded" width={80} height={24} sx={{ borderRadius: 999 }} />
            </TableCell>
            <TableCell>
              <Skeleton variant="text" width={80} height={16} />
            </TableCell>
            <TableCell>
              <Skeleton variant="circular" width={28} height={28} />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
